// extracted by mini-css-extract-plugin
module.exports = {"Valuation":"Valuation_Valuation__4MFTN","overview-page":"Valuation_overview-page__GLXFF"};